import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

export const useStyles = makeStyles(
    (theme: Theme) =>
        createStyles({
            description: {
                marginBottom: '2%',
            },
            banner: {
                marginBottom: '2%',
            },
            cardsContainer: {
                display: 'flex',
                flexWrap: 'wrap',
                columnGap: '1.5%',
                rowGap: '0.5rem',
                marginBottom: '2%',
                '& > *': {
                    flex: '1 1 auto',
                },
            },
            card: {
                [theme.breakpoints.only('xs')]: {
                    width: '100%',
                },
                '&>div': {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                },
            },
            cardHeader: {
                marginBottom: 'auto',
            },
            searchContainerBox: {
                display: 'flex',
                flexWrap: 'wrap',
                flexFlow: 'column',
                justifyContent: 'space-between',
                marginBottom: '2%',
                rowGap: '0.75rem',
                [theme.breakpoints.up('sm')]: {
                    flexFlow: 'row',
                },
            },
            searchContainer: {
                display: 'flex',
                flexWrap: 'wrap',
                columnGap: '1.5%',
                rowGap: '1rem', // does not work well with % on dynamic height parent

                [theme.breakpoints.up('sm')]: {
                    rowGap: '1rem',
                    width: 'calc(100% - 9rem)', // button on the right
                },
            },
            searchBox: {
                [theme.breakpoints.only('xs')]: {
                    width: '100%',
                },
                [theme.breakpoints.only('sm')]: {
                    width: '100%',
                    paddingRight: 0,
                },
                width: '32%',
            },
            filterByTextField: {
                '&>label': {
                    // prevent the label breaking no 1
                    whiteSpace: 'nowrap',
                },
                [theme.breakpoints.only('xs')]: {
                    width: '100%',
                },
                [theme.breakpoints.only('sm')]: {
                    width: '49.25%',
                },
                [theme.breakpoints.between('md', 'xl')]: {
                    width: '32%',
                },
                minWidth: '140px', // prevent the label breaking 2
            },
            checkbox: {
                marginLeft: '-0.375rem', // lower the default
                marginRight: '10px',
            },
            tableContainer: {
                overflowX: 'auto',
            },
            noDataCell: {
                textAlign: 'center',
                fontStyle: 'italic',
            },
            pagination: {
                paddingTop: '2%',
                display: 'flex',
                justifyContent: 'center',
            },
            skeletonFiltersContainer: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: theme.spacing(2),
            },
            skeletonFilter: {
                height: theme.spacing(8),
                width: `calc((100% - ${theme.spacing(2)}px * 2) / 3)`,
            },
            errorMessage: {
                marginTop: theme.spacing(8),
            },
            actionContainer: {
                '&:not(:last-child)': {
                    marginRight: theme.spacing(1),
                },
            },
            actionsContainer: {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                width: '100%',
                height: '100%',
            },
            actionIconWrapper: {
                width: '24px',
                height: '24px',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            },
            actionIcon: {
                color: theme.palette.action.active,
            },
            actionIconDisabled: {
                color: theme.palette.action.disabled,
            },
            createUserButton: {
                width: '120px',
                alignSelf: 'flex-end',
                padding: '0.3125rem 0.9375rem',
                textDecoration: 'none',
                color: theme.palette.text.primary,
                border: `1px solid ${theme.palette.text.primary}`,
                borderRadius: '0.125rem;',
                textAlign: 'center',
            },

            dialogIconWrapper: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '16px',
            },
            dialogPrimaryText: {
                fontWeight: 'bold',
                textAlign: 'center',
                margin: 0,
            },
            dialogSecondaryText: {
                fontStyle: 'italic',
                textAlign: 'center',
                color: '#666',
                lineHeight: '1.4',
            },
            screenReaderOnly: {
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: '0',
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                whiteSpace: 'nowrap',
                border: '0',
            },
            infoIconButton: {
                padding: theme.spacing(0.5),
            },
        }),
    {
        name: 'UserList-',
    },
);
